import { useCallback } from "react";
import classNames from "classnames";
import { defineMessages } from "react-intl";
import { useFormatMessage } from "../Intl/Context";
import { useInputAriaDescribedBy } from "../Form/useInputAriaDescribedBy";

const OtherFieldForSelect = props => {
  const { other, otherValue, onChange } = props;

  const ariaDescribedBy = useInputAriaDescribedBy();

  const handleOtherTextFieldChanged = useCallback(
    e => onChange({ otherValue: e.target.value }),
    [onChange]
  );

  const t = useFormatMessage();
  const otherTextSrLabel = t(intlMessages.otherTextSrLabel);

  if (!other) return null;

  const className = classNames("form-check", "form-check-other", {
    "form-check-selected": other
  });

  return (
    <div className={className}>
      <label className="form-check-other padding-sm d-block">
        <span className="sr-only">{otherTextSrLabel}</span>
        <input
          type="text"
          className="form-control"
          name="otherValue"
          value={otherValue}
          onChange={handleOtherTextFieldChanged}
          aria-describedby={ariaDescribedBy}
        />
      </label>
    </div>
  );
};

const intlMessages = defineMessages({
  otherTextSrLabel: {
    id: "inputs.otherField.otherTextSrLabel",
    defaultMessage: "Autre, précisez:"
  }
});

export default OtherFieldForSelect;
